import React, { useState } from 'react';

import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';

import CreateWorkFeedbackModal from './CreateWorkFeedbackModal';

const useStyles = makeStyles((theme) => ({
  button: {
    '&:hover': {
      backgroundColor: '#388e3c',
    },
    backgroundColor: '#4caf50', // Green color for positive feedback
    color: 'white',
    margin: theme.spacing(1),
  },
}));

const WorkFeedbackButton = () => {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      <Button variant="contained" className={classes.button} startIcon={<ThumbUpAltIcon />} onClick={handleOpenModal}>
        Good Work
      </Button>
      <CreateWorkFeedbackModal open={modalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default WorkFeedbackButton;
